import { create } from 'zustand';

export interface IModal {
  isModalShow: boolean;
  title?: string;
  desc?: string;
  descDiv?: React.ReactNode;
  okBtnText?: string;
  okCallback?: Function;
  isWarning?: boolean;
  closeBtnText?: string;
  closeCallback?: Function;
  image?: null | {
    url: string | null;
    width: number;
    height: number;
  };
}

export interface IModalState extends IModal {
  setModalState: ({
    isModalShow,
    title,
    desc,
    descDiv,
    okBtnText,
    okCallback,
    isWarning,
    closeBtnText,
    closeCallback,
    image,
  }: IModal) => void;
}

const useAlertConfirmStore = create<IModalState>((set) => ({
  isModalShow: false,
  title: '',
  desc: '',
  okBtnText: '',
  okCallback: undefined,
  isWarning: false,
  closeBtnText: '',
  closeCallback: undefined,
  setModalState: ({
    isModalShow,
    title,
    desc,
    descDiv,
    okBtnText,
    okCallback,
    isWarning,
    closeBtnText,
    closeCallback,
    image,
  }: IModal) =>
    set((state) => ({
      isModalShow: isModalShow,
      title: title ?? '',
      desc: desc ?? '',
      descDiv: descDiv ?? undefined,
      okBtnText: okBtnText ?? '확인',
      okCallback: okCallback ?? undefined,
      isWarning: isWarning ?? false,
      closeBtnText: closeBtnText ?? '닫기',
      closeCallback: closeCallback ?? undefined,
      image: image ?? null,
    })),
}));

export default useAlertConfirmStore;
